module.exports = __webpack_public_path__ + "img/20190725161332QQ截图20190725005749.cc0c5d28.png";